import config from '../config.json'

import { useEffect, useContext, useRef } from 'react'
import { GlobalContext } from '../App'
import { getCookie } from './api'

const socketAddress = `${config.enderecoWebSocket}`
const reconnectDelays = [1000, 2000, 5000, 10000, 30000]

const Websocket = () => {
  const { usuarioLogado, socketReceive, dispatch } = useContext(GlobalContext)
  const socketRef = useRef<WebSocket | null>(null)

  useEffect(() => {
    const token = getCookie('token') || usuarioLogado.token

    // O componente existe desde a tela de login, mas o backend só aceita a
    // associação da sessão WebSocket depois que o usuário possui um token.
    if (!token) return

    let socket: WebSocket | null = null
    let reconnectTimer: ReturnType<typeof setTimeout> | undefined
    let stopped = false
    let authenticationRejected = false
    let reconnectAttempt = 0

    const scheduleReconnect = (immediate = false) => {
      if (stopped || authenticationRejected || reconnectTimer) return
      if (!navigator.onLine) return
      const delay = immediate
        ? 0
        : reconnectDelays[
            Math.min(reconnectAttempt, reconnectDelays.length - 1)
          ]
      reconnectAttempt += 1
      reconnectTimer = setTimeout(() => {
        reconnectTimer = undefined
        connect()
      }, delay)
    }

    const connect = () => {
      if (stopped || authenticationRejected) return
      socket = new WebSocket(socketAddress)
      socketRef.current = socket

      socket.onopen = () => {
        console.info('WebSocket conectado')
        socket?.send(
          JSON.stringify({
            T: 'LGN',
            token,
          }),
        )
      }

      socket.onmessage = (event) => {
        try {
          const message = JSON.parse(event.data)

          switch (message.T) {
            case 'AUTH_OK':
              reconnectAttempt = 0
              console.info('WebSocket autenticado')
              break
            case 'AUTH_ERROR':
              authenticationRejected = true
              document.cookie = 'token=; Max-Age=0; path=/; SameSite=Lax'
              localStorage.removeItem('user')
              dispatch({
                type: '',
                field: 'usuarioLogado',
                value: {
                  id: 0,
                  nome: '',
                  email: '',
                  programa: '',
                  token: '',
                  foto: '',
                },
              })
              socket?.close()
              break
            case 'NOT':
              dispatch({
                type: 'receberNotificacao',
                field: '',
                value: message.M,
              })
              break
            case 'MSG':
              console.info('Mensagem WebSocket:', message.M)
              break
            case 'WSMSG':
              socketReceive?.(message.M)
              window.dispatchEvent(
                new CustomEvent('frameworkfl:websocket-message', {
                  detail: message.M,
                }),
              )
              break
            default:
              console.warn('Evento WebSocket desconhecido:', message)
          }
        } catch {
          console.error('Mensagem WebSocket inválida:', event.data)
        }
      }

      socket.onerror = (error) => {
        console.error('Erro no WebSocket', error)
      }

      socket.onclose = () => {
        if (socketRef.current === socket) socketRef.current = null
        scheduleReconnect()
      }
    }

    const reconnect = () => {
      reconnectAttempt = 0
      clearTimeout(reconnectTimer)
      reconnectTimer = undefined
      if (socket && socket.readyState < WebSocket.CLOSING) socket.close()
      else scheduleReconnect(true)
    }

    const reconnectWhenOnline = () => {
      if (!socket || socket.readyState === WebSocket.CLOSED) reconnect()
    }
    window.addEventListener('online', reconnectWhenOnline)
    window.addEventListener('frameworkfl:websocket-reconnect', reconnect)
    connect()

    return () => {
      stopped = true
      clearTimeout(reconnectTimer)
      window.removeEventListener('online', reconnectWhenOnline)
      window.removeEventListener('frameworkfl:websocket-reconnect', reconnect)
      socket?.close()
      socketRef.current = null
    }
  }, [dispatch, socketReceive, usuarioLogado.token])

  return null // Este componente não precisa renderizar nada
}

export default Websocket
